<template>
  <div id="user-item">
    <basic-card class="card" :class="{ deleted: user.deleted }">
      <div class="header">
        <div class="header-info">
          <div class="spacer"></div>
          <div class="username-wrapper">
            <p class="username kaushan-font">{{ user.fullName }}</p>
          </div>
        </div>
        <div class="divider"></div>
      </div>
      <div class="body">
        <div class="profile-img-wrapper">
          <profile-image :user="user" />
        </div>
        <div class="profile-info-wrapper">
          <div class="login-name-wrapper">
            <p class="login-name-title">
              {{ $t("usersScreen.userItem.loginName") }}
            </p>
            <p class="login-name-value">{{ user.username }}</p>
          </div>
          <div class="role-wrapper">
            <p class="role-title">
              {{ $t("usersScreen.userItem.role") }}
            </p>
            <p class="role-value">{{ $t($variables.roles[user.role]) }}</p>
          </div>
          <div class="created-wrapper">
            <p class="created-title">
              {{ $t("usersScreen.userItem.createdAt") }}
            </p>
            <p class="created-value">{{ user.createdDate | formatDate }}</p>
          </div>
        </div>
      </div>
      <div class="footer">
        <template>
          <rounded-button
            v-if="!user.deleted"
            :disabled="deleting"
            width="150px"
            fontSize="14px"
            height="35px"
            buttonType="danger"
            @click="deleteUserClicked"
          >
            {{ $t("usersScreen.userItem.deleteButton") }}
          </rounded-button>
        </template>
        <rounded-button
          width="150px"
          height="35px"
          fontSize="14px"
          position="right"
          @click="editUser"
        >
          {{ $t("usersScreen.userItem.editButton") }}
        </rounded-button>
      </div>
    </basic-card>
  </div>
</template>

<script>
import UserModal from "@/components/modules/Users/UserModal";
import DeleteModal from "@/components/shared/Modals/DeleteModal";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "UserItem",
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      deleting: false
    };
  },
  computed: {
    ...mapGetters({
      getActiveUser: "user/getActiveUser"
    })
  },
  methods: {
    ...mapActions({
      deleteUser: "user/deleteUser"
    }),
    editUser() {
      this.$eventBus.showModal({
        bind: {
          is: UserModal,
          user: this.user,
          width: "500px",
          height: "405px"
        },
        title: this.$t("usersScreen.userModal.edit.title", {
          userName: this.user.fullName
        })
      });
    },
    deleteUserClicked() {
      this.$eventBus.showModal({
        bind: {
          is: DeleteModal,
          height: "200px",
          text: this.$t("usersScreen.deleteModal.text", {
            userName: this.user.fullName
          })
        },
        on: {
          deleteClicked: () => {
            this.deleteUserAction();
          }
        },
        title: this.$t("usersScreen.deleteModal.title")
      });
    },
    deleteUserAction() {
      this.deleting = true;
      this.$eventBus.closeModal();
      this.deleteUser({ id: this.user.id }).then(res => {
        if (res.status === "OK") {
          this.deleting = false;
          this.$emit("userDeleted");
          this.$eventBus.showDropdownNoti({
            icon: "success",
            title: this.$t("usersScreen.deleteNoti.title"),
            text: this.$t("usersScreen.deleteNoti.success.text")
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#user-item {
  position: relative;
  .deleted {
    border: 3px solid red;
  }
  .card {
    width: 100%;
    display: flex;
    flex-direction: column;
    transition: all 0.4s ease-out;
    .header {
      cursor: pointer;
      min-width: 100%;
      margin-bottom: 10px;
      .header-info {
        height: 40px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        .spacer {
          width: 35px;
        }
        .status-sticker {
          img {
            height: 35px;
            width: 35px;
          }
        }
        .username-wrapper {
          .username {
            text-align: center;
            font-size: 25px;
            font-weight: bold;
          }
        }
      }
    }
    .body {
      cursor: pointer;
      display: flex;
      flex-direction: row;
      margin-bottom: 20px;
      .profile-img-wrapper {
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 80px;
          height: 80px;
          object-fit: cover;
          border-radius: 50%;
          border: 1px solid $color-primary;
          padding: 3px;
        }
      }
      .profile-info-wrapper {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        justify-content: space-between;
        .login-name-wrapper {
          display: flex;
          flex-wrap: wrap;
          // gap: 10px;
          .login-name-value {
            margin-left: 5px;
            font-weight: bold;
          }
        }
        .role-wrapper {
          display: flex;
          flex-wrap: wrap;
          // gap: 10px;
          .role-value {
            margin-left: 5px;
            font-weight: bold;
          }
        }
        .created-wrapper {
          display: flex;
          flex-wrap: wrap;
          // gap: 10px;
          .created-value {
            margin-left: 5px;
            font-weight: bold;
          }
        }
      }
    }
    .footer {
      display: flex;
      justify-content: space-between;
      // gap: 10px;
    }
  }
}
@media (max-width: 440px) {
  .login-name-wrapper {
    flex-direction: column !important;
    gap: 0 !important;
    .login-name-title {
      text-align: center !important;
    }
    .login-name-value {
      text-align: center !important;
    }
  }
  .role-wrapper {
    flex-direction: column !important;
    gap: 0 !important;
    .role-title {
      text-align: center !important;
    }
    .role-value {
      text-align: center !important;
    }
  }
  .created-wrapper {
    flex-direction: column !important;
    gap: 0 !important;
    .created-title {
      text-align: center !important;
    }
    .created-value {
      text-align: center !important;
    }
  }
  .footer {
    flex-direction: column-reverse !important;
    #rounded-button-wrapper {
      width: 100% !important;
      margin-bottom: 10px;
    }
  }
}
</style>
